// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"View1_wrapper__11ife","topicTitle":"View1_topicTitle__1e7JA"};